import React from "react";
import Footer_En from '../Components/Footer_En'
import NaviBarv2_En from '../Components/NaviBarv2_En'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container} from 'react-bootstrap';
import conf_ModernProblemsOfInverseProblems from "../images/conf/conf_ModernProblemsOfInverseProblems.png"


export function Conf_innovativeMethods_En () {
  return (
        <>
    <NaviBarv2_En />
    <Container>
    <div><img src={conf_ModernProblemsOfInverseProblems} align="left" width={500} alt="Conference" /></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <div className="row my-4 ps-4"><h2>IV International scientific and practical conference «Innovative methods of mathematics and physics in ecological and hydrometeorological research».</h2></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <hr />
    <div className="row ps-4 my-4"><p className="lead">The conference aims to maintain a high level of scientific discussion about modern types of energy and trends in computer science, methods of their study and development, engaging qualified experts – representatives of science, business and government.</p></div>
    <div className="row ps-4 my-4"><p className="lead">Discussion and exchange of results and prospects for applying innovative methods, achievements and trends of mathematics and physics in hydrometeorological and ecological research.</p></div>
    <div className="row ps-4 my-4"><p className="lead"><b>Conference sections</b><br /> Section 1. Fundamental and applied aspects of higher mathematics in modern research.<br />
Section 2. Physical studies of natural processes.<br />
Section 3. Modern applied information systems and geoinformation technologies.<br />
Section 4. Development of research in hydrometeorology and ecology.<br />
Section 5. (for schoolchildren). Contest of research works «MIP in Nature (mathematics, informatics, physics in nature)». <br /></p></div>

    <div className="row ps-4 my-4"><p className="lead">More detailed information is available on the <a rel="noopener" target="_blank" href="https://immfegi.rshu.ru/home">conference website</a>.</p></div>
    <div className="row ps-4 my-4"><p>13.02.2025</p></div>
    </Container>
    <Footer_En />
    </>

    )}
